import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from 'src/app/services/oauth.service';
import { global } from 'src/app/global';
import * as bigInteger from 'big-integer';
import * as forge from 'node-forge';
import * as crypto from 'crypto-js';

import { SseService } from 'src/app/services/SseService';
import { FormControl } from '@angular/forms';
@Component({
  selector: 'app-iboauth',
  templateUrl: './iboauth.component.html',
  styleUrl: './iboauth.component.scss'
})
export class IboauthComponent implements OnInit, OnDestroy {
  oauthToken: string | null = '';
  oauthVerifier: string | null = '';
  error: string = '';
  accessToken: string = '';
  tokenSecret: string = '';
  myControl = new FormControl();
  oauthVerifierTxt: string;
  tipooauth: number = global.oauth.oauthTipo;
  constructor(private route: ActivatedRoute, private oauthService: OAuthService, private _cookieService: CookieService, private _sseService: SseService) { }
  getOptions(endPoint: string) {
    const options = { ...global.credentials }; // copy
    options.useGw = global.session.useGw;
    if (endPoint) {
      options.endPoint = endPoint;
      options.url = global.session.baseUrl + endPoint;
      options.urlReal = global.session.baseUrlReal + endPoint;
    }
    return options;
  }
  ngOnInit(): void {


    //this.oauthToken = this.route.snapshot.queryParamMap.get('oauth_token') ?? '';
  //  this.oauthVerifier = this.route.snapshot.queryParamMap.get('oauth_verifier') ?? '';

//    this._cookieService.set('oauthToken', this.oauthToken);

  }

public setVerifier(){
  this._cookieService.set('oauthVerifier', this.oauthVerifierTxt);
  console.log(this.oauthVerifierTxt);
  this.obtenertoken();
}

/**
 * El backend firma con la clave del consumer, el navegador envia la peticion a IBKR y el backend
 * calcula y verifica el LST con la respuesta; aqui solo se guarda el resultado. La clave privada
 * ya no viaja al navegador.
 */
public getlivesesssiontoken(){

  this._cookieService.set('accessToken', this.accessToken);

  this.oauthService.generarLiveSessionToken(this._cookieService.get('llave'), this.accessToken, this.tokenSecret)
    .then((lst: string) => {
      global.credentials.liveSessionToken = lst;
      this._cookieService.set('liveSessionToken', lst);
      window.close();
    })
    .catch((err: any) => {
      this.error = OAuthService.mensajeError(err, 'No se pudo generar la sesión con IBKR.');
    });
}

  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }



  calculateLST(
    dhResponse: string,
    dhRandom: string,
    accessTokenSecret: string,
    prime: string
  ): string {
    //if (typeof accessTokenSecret === 'string') {
    //accessTokenSecret = crypto.enc.Hex.parse(accessTokenSecret);

    let K: any;
    const B = bigInteger(dhResponse, 16);
    const a = bigInteger(dhRandom, 16);
    K = B.modPow(a, bigInteger(prime, 16));
    console.log('valor B original: ' + B.toString());
    console.log('valor a original: ' + a.toString());
    console.log('valor K original: ' + K.toString());


    const hash = crypto.HmacSHA1(
      crypto.lib.WordArray.create(this.toByteArray(K)), crypto.enc.Hex.parse(accessTokenSecret)
    );
    console.log('hash: ' + hash);


    return crypto.enc.Base64.stringify(hash);

  }


  verifyLSTOrigi(lst: string, consumerKey: string, lstSignature: string): boolean {
    const hmac = forge.hmac.create();
    hmac.start('sha1', forge.util.decode64(lst));
    hmac.update(consumerKey);
    const toVerify = hmac.digest().toHex();
    console.log(toVerify);
    console.log(lstSignature);
    return toVerify === lstSignature;
  }

  base64ToHex(base64: string): string {
    const raw = atob(base64);  // Decodifica base64 a cadena binaria
    let hex = '';
    for (let i = 0; i < raw.length; i++) {
      const hexChar = raw.charCodeAt(i).toString(16);
      hex += ('00' + hexChar).slice(-2);  // Asegura que siempre sean dos dígitos
    }
    return hex;
  }

  verifyLST(lst: string, consumerKey: string, lstSignature: string): boolean {
    const decodedLst = crypto.enc.Base64.parse(lst);
    const hmac = crypto.HmacSHA1(decodedLst, consumerKey);
    console.log('HMAC', hmac);
    const toVerify = crypto.enc.Hex.stringify(hmac);

    console.log('toVerify:', toVerify);
    console.log('lstSignature:', lstSignature);

    return toVerify === lstSignature;
  }


  toByteArray(x: bigInt.BigInteger): number[] {
    let hexString = x.toString(16);
    if (hexString.length % 2 > 0) {
      hexString = '0' + hexString;
    }
    const byteArray = [];
    if (x.toString(2).length % 8 === 0) {
      byteArray.push(0);
    }
    for (let i = 0; i < hexString.length; i += 2) {
      byteArray.push(parseInt(hexString.slice(i, i + 2), 16));
    }
    return byteArray;
  }

  hexStringToBinary(hex: string): string {
    let binary = '';
    for (let i = 0; i < hex.length; i += 2) {
      binary += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    }
    return binary;
  }
 obtenertoken() {

  if (this._cookieService.check('oauthToken')) {
    // El backend firma la peticion del access token (es quien tiene la clave del consumer) y el
    // navegador la envia a IBKR, como siempre.
    this.oauthService.pedirAccessToken(
        this._cookieService.get('llave'),
        this._cookieService.get('oauthToken'),
        this._cookieService.get('oauthVerifier'))
      .then((res: { oauth_token: string; oauth_token_secret: string }) => {
        this.accessToken = res?.oauth_token;
        this.tokenSecret = res?.oauth_token_secret;
        if (!this.accessToken || !this.tokenSecret) {
          this.error = 'IBKR no devolvió el token de acceso.';
          return;
        }
        this.getlivesesssiontoken();
      })
      .catch((err: any) => {
        this.error = OAuthService.mensajeError(err, 'No se pudo obtener el token de acceso.');
      });
  }
 }
}

